var _ellipse, _g, _path, _path2, _path3, _path4, _path5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNoti({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 113,
    viewBox: "0 0 180 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.02 42.9695)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3571_23039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.75 83C140.959 83 142.75 81.2091 142.75 79L142.75 33C142.75 30.7909 140.959 29 138.75 29L25.25 29C23.0409 29 21.25 30.7909 21.25 33L21.25 79C21.25 81.2091 23.0409 83 25.25 83L138.75 83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25 33L142.25 79C142.25 80.933 140.683 82.5 138.75 82.5L25.25 82.5C23.317 82.5 21.75 80.933 21.75 79L21.75 33C21.75 31.067 23.317 29.5 25.25 29.5L138.75 29.5C140.683 29.5 142.25 31.067 142.25 33Z",
    stroke: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8373 69.1624H61.315C62.7353 69.1624 63.4455 69.1624 63.837 68.8663C64.178 68.6083 64.389 68.2139 64.4145 67.7871C64.4438 67.2971 64.0498 66.7062 63.262 65.5244L58.8593 58.9204C58.2083 57.9439 57.8828 57.4557 57.4726 57.2855C57.1139 57.1368 56.7108 57.1368 56.3521 57.2855C55.9418 57.4557 55.6163 57.9439 54.9653 58.9204L53.8769 60.553M59.8373 69.1624L48.5988 52.9289C47.9524 51.9953 47.6292 51.5285 47.2256 51.3644C46.8724 51.2209 46.4772 51.2209 46.1241 51.3644C45.7204 51.5285 45.3972 51.9953 44.7509 52.9289L36.0544 65.4904C35.231 66.6798 34.8193 67.2745 34.8427 67.7691C34.8632 68.1999 35.0726 68.5996 35.4151 68.8616C35.8085 69.1624 36.5318 69.1624 37.9784 69.1624H59.8373ZM62.7623 47.2249C62.7623 49.6481 60.798 51.6124 58.3748 51.6124C55.9517 51.6124 53.9873 49.6481 53.9873 47.2249C53.9873 44.8018 55.9517 42.8374 58.3748 42.8374C60.798 42.8374 62.7623 44.8018 62.7623 47.2249Z",
    stroke: "#C4D9FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8056 52.929L36.1091 65.4905C35.2857 66.6799 34.874 67.2746 34.8974 67.7692C34.9178 68.2 35.1273 68.5997 35.4698 68.8617C35.8631 69.1625 36.5864 69.1625 38.0331 69.1625H59.892L48.6534 52.929C48.0071 51.9954 47.6839 51.5286 47.2803 51.3645C46.9271 51.2209 46.5319 51.2209 46.1788 51.3645C45.7751 51.5286 45.4519 51.9954 44.8056 52.929Z",
    fill: "#C4D9FE",
    stroke: "#C4D9FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1992 47.9C97.7515 47.9 98.1992 47.4523 98.1992 46.9L98.1992 43.5C98.1992 42.9477 97.7515 42.5 97.1992 42.5L77.5992 42.5C77.0469 42.5 76.5992 42.9477 76.5992 43.5L76.5992 46.9C76.5992 47.4523 77.0469 47.9 77.5992 47.9L97.1992 47.9Z",
    fill: "#F6F6F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135 58.7001C135.552 58.7001 136 58.2523 136 57.7001L136 54.3C136 53.7478 135.552 53.3 135 53.3L77.6 53.3C77.0477 53.3 76.6 53.7478 76.6 54.3L76.6 57.7C76.6 58.2523 77.0477 58.7 77.6 58.7L135 58.7001Z",
    fill: "#C4D9FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.051 69.5001C112.603 69.5001 113.051 69.0524 113.051 68.5001L113.051 65.1001C113.051 64.5478 112.603 64.1001 112.051 64.1001L77.6008 64.1001C77.0485 64.1001 76.6008 64.5478 76.6008 65.1001L76.6008 68.5001C76.6008 69.0524 77.0485 69.5001 77.6008 69.5001L112.051 69.5001Z",
    fill: "#C4D9FE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3571_23039)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 29.5,
    r: 5.5,
    fill: "#E3ECFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3571_23039",
    x: 17.25,
    y: 29,
    width: 129.5,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3571_23039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3571_23039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3571_23039",
    x: 105,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3571_23039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3571_23039",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNoti);
export default __webpack_public_path__ + "static/media/emptyNoti.14391203.svg";
export { ForwardRef as ReactComponent };